import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaMinus(complexDenominator, c1, r1, r5, sImaginary) {
  var result = Complex.createComplex(r1 + r5, c1 * r1 * r5 * sImaginary).divide(complexDenominator);
  return result;
}

export function computeComplexFF(complexFFDenominator, c1, c2, r1, r5, rOut, sImaginary) {
  var complexFFNumerator = Complex.createComplex(1, sImaginary * r1 * c1).mult(
    Complex.createComplex(0, sImaginary * rOut * r5 * c2),
  );
  var result = complexFFNumerator.divide(complexFFDenominator);
  return result;
}
